import { useCanAccess } from "ra-core";

/**
 * Whether the logged-in user is an administrator.
 *
 * Administrator status is not carried on the identity object, so it is derived
 * from access to the `sales` resource, which `canAccess` grants to admins only.
 * This is the same signal the header uses to show the Users menu.
 */
export const useIsAdmin = () => {
  const { canAccess, isPending } = useCanAccess({
    resource: "sales",
    action: "list",
  });

  return { isAdmin: !!canAccess, isPending };
};
